export default __webpack_public_path__ + "static/media/fire.c49ff5fd.jpg";